import InputComponent from './input';
import CheckboxComponent from './checkbox';
import CheckboxBtnComponent from './checkboxbtn';
import CurrencyComponent from './currency';

export const Currency = CurrencyComponent;
export const Input = InputComponent;
export const CheckBox = CheckboxComponent;
export const CheckboxBtn = CheckboxBtnComponent;

export default Input;



// WEBPACK FOOTER //
// ./app/components/Forms/UI/Input/index.js